/* eslint-disable max-len */
import { useLazyQuery } from '@apollo/client';
// import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { ADMIN_VIEW_DOCUMENT } from '../../graphql/admin_queries';
import AcceptedDocIcon from '../../svgs/AcceptedDocIcon';
import ActivityStatusIcon from '../../svgs/ActivityStatusIcon';
import EmptyMerchantLogo from '../../svgs/EmptyMerchantLogo';
import PdfIcon from '../../svgs/PdfIcon';
import RejectedDocIcon from '../../svgs/RejectedDocIcon';
import { capitalizeEverFirstLetter, convertUrlToHTTPS } from '../../utils/helpers';
import RejectFile from './RejectFile';
import UploadFile from './UploadFile';
import ViewFile from './ViewFile';

interface IViewImageComponent{
  docType?:any;
  onClick?:any;
  name?:string;
  payload?:any;
  uploadType?: boolean;
  fetchKyc?:any;
  merchantId?:string;
  pageName:any;
  imageSize?:any;
  imageType?:any;
  fileExt?:any;
  fetchUser?:any;
  uploadDocumentType?:string;
  hideActions?: boolean;
  disabled?: boolean;
  canUpdatePermission?:string;
  canAcceptPermission?:string;
  canRejectPermission?:string;
  showStatusIcon?: boolean;
}
const ViewImageComponent = ({
  docType, name, payload, uploadType, fetchKyc, merchantId, imageType, fileExt, fetchUser, uploadDocumentType, hideActions, disabled, canUpdatePermission, canAcceptPermission, canRejectPermission, showStatusIcon,
}:IViewImageComponent) => {
  // const Toast = useToast();
  const [getDocumentUrl] = useLazyQuery<
  { viewDocumentUsingID: any },
  any
>(ADMIN_VIEW_DOCUMENT, {
  nextFetchPolicy: 'no-cache',
  fetchPolicy: 'no-cache',
  notifyOnNetworkStatusChange: true,

});
  useEffect(() => {
    getDocumentUrl();
  }, [payload?.status]);

  const statusIcons = {
    1: AcceptedDocIcon,
    '-1': RejectedDocIcon,
    0: () => <ActivityStatusIcon color="#d8e6ff" width={16} height={16} />,
  };
  const Icon = statusIcons[`${payload?.status || 0}`];
  const [getDocType, setDocType] = useState('');
  const [documentUrl, setDocumentUrl] = useState('');
  const [CloseModal, setCloseModal] = useState(false);
  const [ShowActiveFile, setShowActiveFile] = useState('');
  const [ShowRejectModal, setShowRejectModal] = useState(false);
  const [uploadModal, setUploadModal] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const getExtension = (filename:any) => {
    const parts = filename.split('.');
    return parts[parts.length - 1];
  };
  const docChecker = () => {
    const ext = getExtension(docType);
    switch (ext.toLowerCase()) {
    case 'jpg':
    case 'png':
    case 'jpeg':
    case 'svg':
    case 'webp':
    case 'image/jpeg':
    case 'image/png':
    case 'image/jpg':
    case 'image/svg':
    case 'image/webp':
    case 'octet-stream':

      return setDocType('image');
    case 'pdf':
    case 'file':
      return setDocType('pdf');

    default:
      setDocType('pdf');
      break;
    }
  };

  const docCheckerFileExt = () => {
    const ext = getExtension(fileExt);
    switch (ext.toLowerCase()) {
    case 'jpg':
    case 'png':
    case 'jpeg':
    case 'svg':
    case 'webp':
    case 'image/jpeg':
    case 'image/png':
    case 'image/jpg':
    case 'image/svg':
    case 'image/webp':
    case 'octet-stream':

      return setDocType('image');
    case 'pdf':
    case 'file':

      return setDocType('pdf');

    default:
      break;
    }
  };
  const docCheckerImageType = () => {
    const ext = getExtension(imageType);
    switch (ext.toLowerCase()) {
    case 'jpg':
    case 'png':
    case 'jpeg':
    case 'svg':
    case 'webp':
    case 'image/jpeg':
    case 'image/png':
    case 'image/jpg':
    case 'image/svg':
    case 'image/webp':
    case 'octet-stream':

      return setDocType('image');
    case 'pdf':
    case 'file':

      return setDocType('pdf');

    default:
      break;
    }
  };
  const loadData = async () => {
    try {
      if (!payload?.docKey || !payload?.id) {
        const docUrl = convertUrlToHTTPS(payload?.uri || payload?.frontImage || payload?.fileUrl);
        setDocumentUrl(docUrl);
        return docUrl;
      }
      const result = await getDocumentUrl({
        variables: {
          id: payload?.id,
        },
      });
      if (result?.data?.viewDocumentUsingID?.status === 200) {
        setDocumentUrl(result?.data?.viewDocumentUsingID?.url);
        return result?.data?.viewDocumentUsingID?.url;
      }
      // Toast.error('Document cannot be viewed. Contact Support');
    } catch (error) {
      // Toast.error('Document cannot be viewed. Contact Support');
    }
  };
  useEffect(() => {
    if (docType) {
      docChecker();
      loadData();
    }
  }, [docType]);
  useEffect(() => {
    if (fileExt) {
      docCheckerFileExt();
      loadData();
    }
  }, [fileExt]);
  useEffect(() => {
    if (imageType) {
      docCheckerImageType();
      loadData();
    }
  }, [imageType]);

  const handleView = async (file) => {
    setCloseModal(true);
    setLoading(true);
    await loadData();
    setLoading(false);
    setShowActiveFile(file);
  };

  const handleShowReject = () => {
    setCloseModal(false);
    setShowRejectModal(true);
  };

  const getFileComponent = () => (
    <div className="view-image-comp-cover">
      <div
        className="view-image-name"
        style={{
          ...(
            disabled ? { cursor: 'not-allowed' } : {}
          ),
        }}
      >
        {
          getDocType === 'image' ? docType ? <img src={documentUrl || docType} alt="logo" className="image" /> : <EmptyMerchantLogo /> : getDocType === 'pdf' ? <PdfIcon /> : <EmptyMerchantLogo />
        }
        <span>{name ? capitalizeEverFirstLetter(name)?.split?.('_')?.join(' ') : name || (docType ? 'Merchant Logo' : 'No Logo Uploaded')}</span>
      </div>
      {disabled
        ? (
          <div
            className="file-upload-doc-btn"
          >
            {(uploadType && !docType) ? (
              <div
                className="view-image-button active"
                style={{
                  ...(
                    disabled ? { cursor: 'not-allowed', color: '#98A2B3' } : {}
                  ),
                }}
              >
                Upload
              </div>
            )
              : (
                <div
                  className={`view-image-button ${docType ? 'active' : 'inactive'}`}
                  style={{
                    ...(
                      disabled ? { cursor: 'not-allowed', color: '#98A2B3' } : {}
                    ),
                  }}
                >
                  VIEW
                </div>
              )}
            {showStatusIcon && <div className="icon"><Icon /></div>}
          </div>
        )
        : (
          <div
            className="file-upload-doc-btn"
          >
            {(uploadType && !docType) ? <div className="view-image-button active" onClick={() => setUploadModal(true)}>Upload</div>
              : <div className={`view-image-button ${docType ? 'active' : 'inactive'}`} onClick={() => handleView(documentUrl || docType)}>VIEW</div>}
            {showStatusIcon && <div className="icon"><Icon /></div>}
          </div>
        )}
    </div>
  );
  return (
    <div>
      {/* <img src={documentUrl} alt="working" /> */}
      <div>
        {getFileComponent()}
        {/* <div className="file-size-cover">
          {' '}
          File size:
          {' '}
          {getFileSize(imageSize || payload?.meta?.file_size || 0)}
          {' '}
          Kb
        </div> */}
      </div>

      {
        CloseModal && (
        <ViewFile
          setUploadModal={setUploadModal}
          loadData={loadData}
          loading={loading}
          fileType={getDocType}
          file={ShowActiveFile}
          handleClose={() => setCloseModal(false)}
          payload={payload}
          handleShowReject={handleShowReject}
          fetchKyc={fetchKyc}
          fetchUser={fetchUser}
          viewDocumentType={uploadDocumentType}
          id={merchantId}
          hideActions={hideActions}
          canUpdatePermission={canUpdatePermission}
          canRejectPermission={canRejectPermission}
          canAcceptPermission={canAcceptPermission}

        />
        )
      }
      {
        ShowRejectModal && <RejectFile id={merchantId} rejectDocumentType={uploadDocumentType} fetchUser={fetchUser} fetchKyc={fetchKyc} closeModal={() => setShowRejectModal(false)} payload={payload} />
      }
      {
        uploadModal && (
        <UploadFile
          fetchKyc={fetchKyc}
          closeModal={() => setUploadModal(false)}
          merchantId={merchantId}
          documentType={payload?.documentType || name}
          fetchUser={fetchUser}
          uploadDocumentType={uploadDocumentType}
          uploadPermissionName={canUpdatePermission}
        />
        )
      }
    </div>
  );
};
export default ViewImageComponent;
